import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';

/**
 * Acts as a transparent overlay to catch clicks, so that any click outside
 * of the popup content, including within the TV chart (which is an `iframe`,
 * so the app doesn't know when clicks happen inside of it), results in the
 * popup closing.
 *
 * Unfortunately this also has to live outside of the `PopoverWrapper` component
 * because on mobile a touch outside will also trigger any interactive element
 * (e.g. a button) that's located underneath the touch in the DOM. This is due
 * to a synthetic click event  being fired by `touchend`. So on mobile we have to
 * delay closing this component just long enough to run `preventDefault` on `touchend`.
 * See `usePopupOverlay` for more details.
 *
 * Limitation: For nested popups, only a single overlay below the first popup will render.
 */
export default function PopupOverlay() {
	const popups = useVelocityStore((s) => s.popups);

	if (!popups.overlay.show) {
		return null;
	}

	return (
		<div
			id="popup-overlay"
			className="fixed inset-0"
			// Have to get this from state because popups support a custom `z-index`.
			// See `PopoverWrapper` for the entry point.
			style={{ zIndex: popups.overlay.zIndex }}
			// On mobile, prevents extra click from being triggered on elements
			// underneath the user's press. See `usePopupOverlay` for more details.
			onTouchEnd={(e) => e.preventDefault()}
		/>
	);
}
